import { render, staticRenderFns } from "./PrivacyPolicyZHTW.vue?vue&type=template&id=27357510&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicyZHTW.vue?vue&type=style&index=0&id=27357510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27357510",
  null
  
)

export default component.exports